const t = { last_updated: "Letzte Aktualisierung", Series_type: "Edition", "How to guide_type": "Anleitung", FAQ_type: "Standard" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies22.js.map
